import React, { useState } from 'react'; 

const UpdateResumeModal = ({ isOpen, onClose, onConfirm, isUpdating, setSnackbar }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                setError('File size must be less than 10MB.');
                setFileName('');
                setSelectedFile(null);
                return;
            }

            const allowed = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowed.includes(file.type)) {
                setError('Invalid file type. Use PDF or DOCX.');
                setFileName('');
                setSelectedFile(null);
                return;
            }

            setSelectedFile(file);
            setFileName(file.name);
            setError('');
        } else {
            setFileName('');
            setSelectedFile(null);
            setError('');
        }
    };

        const handleConfirmClick = () => {
            // Ensure a file is selected before confirming
            if (selectedFile) {
                // Build FormData so callers that expect multipart/form-data can receive it directly.
                // Also still pass the raw File if parent prefers that.
                const formData = new FormData();
                // Use both common keys 'resume' and 'resumes' to be compatible with backend handlers
                formData.append('resume', selectedFile);
                formData.append('resumes', selectedFile);

                // If parent expects FormData, it can detect and use it. Otherwise pass the File as fallback.
                try {
                    onConfirm(formData, selectedFile);
                } catch (err) {
                    // Fallback: call with file only
                    onConfirm(selectedFile);
                }
            } else {
                setError('No resume files provided');
            }
        };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center">
            <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full">
                <h2 className="text-xl font-semibold mb-4">Update Resume</h2>
                
                {error && <p className="text-red-500 mb-4">{error}</p>}

                <div className="mb-4">
                    <label htmlFor="resume-upload" className="block text-sm font-medium text-gray-700 mb-2">
                        Upload new resume (PDF or DOCX, max 10MB)
                    </label>
                    <input
                        type="file"
                        id="resume-upload"
                        accept=".pdf,.docx"
                        onChange={handleFileChange}
                        className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
                    />
                    {fileName && <p className="mt-2 text-sm text-gray-500">Selected file: {fileName}</p>}
                </div>
                
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
                        disabled={isUpdating}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirmClick}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50"
                        disabled={isUpdating || !selectedFile}
                    >
                        {isUpdating ? 'Updating...' : 'Confirm Update'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpdateResumeModal;